export default "assets/images/icons/back-4d7c39cb.svg";